'use strict';

export function _setState(cam, state) {
  return cam.setState(state);
}
